export { clinicsFetch } from './fetchClinics.js'
export { checkPrerequisites } from './checkPrerequisites.js'
export { normalizeTerms } from './normalizeTerms.js'
export { noteAutocomplete } from './noteAutocomplete.js'
